// Mobil ilovalar — xizmat sahifasi kontenti (uz / ru)
// SEO: "mobil ilova yaratish", "mobil ilova narxi", "iOS Android ilova",
// "React Native", "ilova yasash", "Play Market'ga chiqarish".

const uz = {
    meta: {
        title: "Mobil ilova yaratish — iOS va Android bitta narxda, 45 mln so'mdan",
        description:
            "Innobek'da mobil ilova yaratish 45 mln so'mdan boshlanadi va narx iOS bilan Android uchun birgalikda. React Native, push-bildirishnoma, to'lov, App Store va Play Market'ga chiqarish kiradi.",
        keywords: [
            "mobil ilova yaratish",
            "mobil ilova narxi",
            "ios ilova yaratish",
            "android ilova yaratish",
            "react native ilova",
            "ilova yasash Toshkent",
            "mobil ilova buyurtma qilish",
            "play market ilova joylashtirish",
        ],
    },
    hero: {
        eyebrow: "Mobil ilovalar / iOS va Android",
        h1: "Mobil ilova yaratish — iOS va Android bitta narxda",
        lead:
            "Ikkita alohida jamoa va ikkita byudjet shart emas. Biz React Native'da quramiz: bitta kod bazasidan iOS va Android chiqadi, ikkalasi bir xil ishlaydi, yangilanish esa ikkala do'konga bir vaqtda yetadi. Store'ga joylashtirish ham narxga kiradi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Play Market'da ishlab turgan ilovalar",
            "iOS + Android bitta narxda",
            "Har 2 haftada test versiyasi",
            "Kod va store akkaunti sizniki",
        ],
    },
    intro: {
        h: "Mobil ilova nima uchun kerak va u qanday quriladi?",
        p: [
            "Mobil ilova saytdan ikki jihati bilan farq qiladi. Birinchisi — u telefon ekranida doimo turadi, mijoz sizni qidirib topmaydi, shunchaki ikonani bosadi. Ikkinchisi — push-bildirishnoma: buyurtma holati, aksiya yoki eslatma bir soniyada yetib boradi va bu SMS'dan farqli o'laroq bepul.",
            "Uchinchi sabab texnik: ilova telefonning o'z imkoniyatlarini ishlatadi. Kamera bilan shtrix-kod skanerlaysiz, GPS bilan kuryerni kuzatasiz, internet uzilganda ham ma'lumot telefon xotirasida saqlanib turadi, kirish esa barmoq izi yoki Face ID orqali bo'ladi. Brauzerda bularning aksariyati ishlamaydi yoki cheklangan holda ishlaydi.",
            "Shu bilan birga ilova har bir biznesga kerak emas. Agar mijozingiz yiliga bir-ikki marta murojaat qilsa, mobilga moslashgan sayt ancha arzon va yetarli bo'ladi. Ilova takroriy foydalanish bo'lganda o'zini oqlaydi: yetkazib berish, ta'lim, tibbiyot, sodiqlik dasturi, logistika yoki xodimlar uchun ish quroli.",
            "Innobek jamoasi React Native bilan ishlaydi va backend'ni Nest.js'da quradi. Logistatrans, Besh Market, Bobo Market, My Yurist va FireWise ilovalari aynan shu yondashuvda yig'ilgan — barchasi Play Market'da mavjud. Bitta kod bazasi degani byudjet ikki barobar oshmaydi va ikkala platformada funksiya bir xil bo'ladi.",
            "Ish tartibi ham oddiy. Avval funksiyalar ro'yxatini birga saralaymiz va birinchi versiyaga faqat haqiqatan kerak bo'lganini kiritamiz. Keyin Figma'da dizayn chiziladi, siz prototipni bosib ko'rasiz, shundan so'ng dasturlash boshlanadi. Har ikki haftada ishlaydigan versiya topshiriladi, ya'ni siz natijani oxirida emas, jarayon davomida ko'rasiz va yo'nalishni o'zgartira olasiz.",
        ],
    },
    definition: {
        term: "Mobil ilova nima?",
        text:
            "Mobil ilova — telefon yoki planshetga o'rnatiladigan dastur. U push-bildirishnoma yuboradi, kamera, GPS va oflayn xotira kabi qurilma imkoniyatlaridan foydalanadi va App Store hamda Play Market orqali tarqatiladi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Quyidagilar alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va g'oyani texnik baholash",
            "Funksiyalarni saralash: birinchi versiyaga nima kiradi",
            "Figma'da to'liq dizayn va interaktiv prototip",
            "iOS va Android uchun yagona kod bazasi (React Native)",
            "Backend, API va ma'lumotlar bazasi",
            "Kontent va foydalanuvchilarni boshqarish uchun admin panel",
            "Push-bildirishnoma tizimini sozlash",
            "Store uchun ikona, skrinshot va tavsif tayyorlash",
            "App Store va Play Market'ga joylashtirish, moderatsiyadan o'tkazish",
            "Analitika va nosozlik hisobotlarini (crash reporting) ulash",
            "Git repozitoriysi va kodning to'liq mulkchiligi sizda",
            "Ishga tushgandan keyin 6 oy texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Mobil ilova biznesga nima beradi",
        sub: "Ilova — yangi reklama kanali emas, mijozni ushlab qolish vositasi.",
        items: [
            {
                t: "Push — eng arzon aloqa kanali",
                d: "SMS har bir xabar uchun pul turadi, e-mail esa ochilmay qoladi. Push bepul va ekranda darhol ko'rinadi: buyurtma holati, aksiya, eslatma va shaxsiy taklif bir bosishda yetib boradi.",
            },
            {
                t: "Takroriy buyurtma o'sadi",
                d: "Ilova o'rnatgan mijoz sizni Google'dan qidirmaydi va raqobatchi reklamasiga tushmaydi. U ikonani bosadi, oldingi buyurtmani takrorlaydi va to'lov ma'lumotini qayta kiritmaydi.",
            },
            {
                t: "Telefon imkoniyatlari ochiladi",
                d: "Kamera orqali skaner va hujjat yuklash, GPS orqali yetkazib berish kuzatuvi, oflayn rejim, barmoq izi bilan kirish, kontakt va taqvim bilan bog'lanish — bularning bari ilovada mavjud.",
            },
            {
                t: "Bitta kod, ikkita platforma",
                d: "React Native iOS va Android'ni bitta koddan chiqaradi. Byudjet ikki barobar bo'lmaydi, tuzatish ikkala platformaga bir vaqtda yetadi va funksiyalar orasida farq qolmaydi.",
            },
            {
                t: "Xodimlar uchun ish quroli",
                d: "Kuryer, sotuvchi, omborchi yoki dala xodimi uchun ilova qog'oz hisobotni almashtiradi. Ma'lumot joyida kiritiladi, boshqaruv esa uni real vaqtda ko'radi.",
            },
            {
                t: "O'lchanadigan xatti-harakat",
                d: "Analitika har bir ekranni ko'rsatadi: qayerda foydalanuvchi to'xtaydi, qaysi tugma bosilmaydi, qanchasi ikkinchi marta qaytadi. Keyingi versiyani taxmin emas, raqam asosida rejalashtirasiz.",
            },
            {
                t: "To'lov jarayoni qisqaradi",
                d: "Karta ma'lumoti bir marta saqlanadi, keyingi buyurtmada esa ikki bosish yetarli. Payme, Click va Uzum integratsiyasi bilan to'lovdan voz kechish ulushi saytdagiga nisbatan sezilarli kamayadi.",
            },
            {
                t: "Bozorda ishonch belgisi",
                d: "App Store va Play Market moderatsiyasidan o'tgan ilova kompaniya jiddiy ishlayotganini ko'rsatadi. Bu ayniqsa yangi brend va tender ishtirokchilari uchun muhim argument bo'ladi.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlar buyurtma qiladi",
        h: "Qanaqa bizneslarga mobil ilova mos keladi",
        sub: "Mijoz yoki xodim tizimga tez-tez, takroran kiradigan holatlar.",
        items: [
            {
                t: "Yetkazib berish va savdo",
                d: "Katalog, savat, onlayn to'lov, buyurtma kuzatuvi va push orqali aksiya xabarlari.",
            },
            {
                t: "Logistika va kuryer xizmati",
                d: "Haydovchi ilovasi: marshrut, GPS, yuk hujjatini skanerlash va holatni joyidan yangilash.",
            },
            {
                t: "Ta'lim va kurslar",
                d: "Video darslar, testlar, davomat, sertifikat va uy vazifasi bo'yicha eslatmalar.",
            },
            {
                t: "Tibbiyot va sog'liq",
                d: "Shifokorga yozilish, tahlil natijalari, dori qabuli eslatmasi va klinika bilan aloqa.",
            },
            {
                t: "Sodiqlik va xizmat ko'rsatish",
                d: "Bonus ballar, raqamli karta, shaxsiy takliflar va onlayn navbat olish.",
            },
            {
                t: "Ichki korporativ ilova",
                d: "Smena va davomat, vazifalar, ombor skaneri hamda dala xodimlari hisoboti.",
            },
            {
                t: "Sport zali va go'zallik saloni",
                d: "Abonement, mashg'ulotlar jadvali, ustaga yozilish va mashg'ulot oldidan eslatma.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Mobil ilova narxi — uchta tarif",
        sub: "Har bir tarifdagi narx iOS va Android uchun birgalikda ko'rsatilgan.",
        note:
            "Yakuniy hisob-kitob bepul tahlil va funksiyalar ro'yxati kelishilgandan keyin tasdiqlanadi. To'lov sprintlar bo'yicha bosqichma-bosqich amalga oshiriladi. Developer akkaunt to'lovlari (Apple — yiliga 99 dollar, Google — bir martalik 25 dollar) va bulut xarajatlari provayderga to'g'ridan-to'g'ri to'lanadi.",
        tiers: [
            {
                name: "Start",
                tagline: "Asosiy funksional bilan birinchi versiya",
                price: "45 000 000",
                priceNote: "so'mdan",
                term: "3–4 oy",
                best: "G'oyani bozorda tez sinab ko'rmoqchi bo'lgan kompaniyalarga",
                features: [
                    "iOS va Android bitta koddan (React Native)",
                    "Figma'da individual dizayn",
                    "Ro'yxatdan o'tish, kirish va profil",
                    "4–6 ta asosiy ekran va bitta mahsulot stsenariysi",
                    "Push-bildirishnomalar",
                    "Backend, API va admin panel",
                    "App Store va Play Market'ga chiqarish",
                    "Analitika va crash reporting",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "To'lov va integratsiyali to'laqonli mahsulot",
                price: "90 000 000",
                priceNote: "so'mdan",
                term: "5–8 oy",
                best: "Bir nechta rol, onlayn to'lov va tashqi tizim integratsiyasi bo'lgan loyihalarga",
                featured: true,
                features: [
                    "Start tarifidagi hamma narsa",
                    "10–18 ta ekran va kengaytirilgan mantiq",
                    "Onlayn to'lov: Payme, Click, Uzum va bank kartasi",
                    "Bir nechta rol: mijoz, kuryer, menejer, administrator",
                    "Xarita, GPS kuzatuv va geolokatsiya",
                    "Kamera: QR va shtrix-kod skaneri, hujjat yuklash",
                    "Oflayn rejim va ma'lumotni sinxronizatsiya qilish",
                    "CRM, 1C yoki ERP bilan integratsiya",
                    "Sodiqlik dasturi va segmentlangan pushlar",
                    "Ko'p tillilik, barmoq izi va Face ID bilan kirish",
                    "Texnik hujjatlar va kodni to'liq topshirish",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Yuqori yuklama va maxsus talablar uchun",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Native modul, uskuna yoki sun'iy intellekt talab qiladigan yirik tizimlarga",
                features: [
                    "Swift va Kotlin'da native modullar",
                    "Sun'iy intellekt: tavsiya, tanib olish, ovozli boshqaruv",
                    "Uskuna bilan ishlash: Bluetooth, NFC, chek printeri, terminal",
                    "Bir nechta mamlakat, valyuta va yuridik shaxs",
                    "Yuklamaga chidamli infratuzilma va monitoring",
                    "Xavfsizlik auditi va shaxsiy ma'lumotlar himoyasi",
                    "Doimiy mahsulot jamoasi (dedicated team) modeli",
                    "Kelishilgan SLA bo'yicha qo'llab-quvvatlash",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Mobil ilova qanday quriladi",
        sub: "Sprintlar bo'yicha ishlaymiz — har ikki haftada test versiyasini telefoningizga o'rnatasiz.",
        steps: [
            {
                t: "Tahlil va doira belgilash",
                d: "Foydalanuvchi kim, ilova qaysi vazifani yopadi va birinchi versiyaga nima kirishini yozib chiqamiz. Shu bosqichda aniq narx va muddat tasdiqlanadi.",
                time: "1–2 hafta",
            },
            {
                t: "Dizayn va prototip",
                d: "Barcha ekranlar Figma'da chiziladi. Interaktiv prototipni telefonda bosib ko'rasiz — tuzatishlar kod yozilmasidan oldin kiritiladi va bu byudjetni tejaydi.",
                time: "3–5 hafta",
            },
            {
                t: "Backend va API",
                d: "Ma'lumotlar bazasi, API va admin panel quriladi. Sizda tayyor tizim bo'lsa, ilova o'sha bazaga ulanadi va ma'lumot ikkilanmaydi.",
                time: "3–6 hafta",
            },
            {
                t: "Ilovani dasturlash",
                d: "Ekranlar navbat bilan yig'iladi va har sprint oxirida ishlaydigan versiya topshiriladi. Siz uni haqiqiy telefonda sinab, fikr bildirasiz.",
                time: "6–16 hafta",
            },
            {
                t: "Sinov va tuzatish",
                d: "Turli telefon modellari, ekran o'lchamlari, sekin internet va uzilgan aloqa stsenariylarida tekshiramiz. Topilgan xatolar chiqarishdan oldin yopiladi.",
                time: "2–3 hafta",
            },
            {
                t: "Store'ga chiqarish",
                d: "App Store va Play Market'ga joylashtiramiz, moderatsiyadan o'tkazamiz, analitika va push kanallarini ishga tushiramiz.",
                time: "1–3 hafta",
            },
            {
                t: "Qo'llab-quvvatlash va o'sish",
                d: "Birinchi oylarda raqamlarni kuzatamiz, xatolarni tuzatamiz va keyingi versiya uchun funksiyalarni foydalanish statistikasiga qarab tanlaymiz.",
                time: "6 oy va undan keyin",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan mobil ilovalar",
        sub: "Barchasi React Native'da yig'ilgan va Play Market'da ishlab turibdi.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["logistatrans-app", "besh-market-app", "bobo-market-app", "myyurist-app", "firewise-app", "anibla"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Mobil ilova bo'yicha ko'p beriladigan savollar",
        sub: "Buyurtmadan oldin eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Mobil ilova yaratish qancha turadi?",
                a: "Narx 45 000 000 so'mdan boshlanadi va bu summa iOS bilan Android uchun birgalikda. Bazaviy tarifga ro'yxatdan o'tish, 4–6 ta asosiy ekran, push-bildirishnomalar, backend va store'ga chiqarish kiradi. To'lov tizimi, xarita, oflayn rejim va bir nechta rol kerak bo'lsa, tarif 90 000 000 so'mdan boshlanadi. Aniq raqam funksiyalar ro'yxati kelishilgach tasdiqlanadi.",
            },
            {
                q: "iOS va Android uchun alohida to'lanadimi?",
                a: "Yo'q. React Native'da bitta kod bazasidan ikkala platforma chiqadi, shuning uchun narx bitta. Bu byudjetni sezilarli kamaytiradi va yangilanishlar ikkala do'konga bir vaqtda yetishini ta'minlaydi. Faqat Apple va Google'ning developer akkaunt to'lovlari alohida bo'lib, ular to'g'ridan-to'g'ri provayderga o'tkaziladi. Dizayn, backend va admin panel ham ikkala platforma uchun bitta marta quriladi, shuning uchun ish hajmi takrorlanmaydi.",
            },
            {
                q: "Mobil ilova qancha vaqtda tayyor bo'ladi?",
                a: "Start tarifi 3–4 oyda, Business tarifi 5–8 oyda topshiriladi. Sprintlar bo'yicha ishlaganimiz uchun birinchi ishlaydigan versiyani 5–6 haftadan keyin telefoningizga o'rnatib sinab ko'rasiz. Muddat funksiyalar soniga va tashqi tizimlar bilan integratsiya murakkabligiga bog'liq. Eng ko'p vaqt yeydigan bosqich — to'lov va CRM integratsiyasi, shuning uchun uni jarayonning boshida rejalashtiramiz. Sizning tomoningizdan qaror tez qabul qilinsa, muddat qisqaradi.",
            },
            {
                q: "React Native native ilovadan qolishmaydimi?",
                a: "Biznes ilovalarning aksariyati uchun farq sezilmaydi: interfeys silliq ishlaydi, push, kamera, GPS, to'lov va oflayn rejim to'liq mavjud. Native kod faqat og'ir 3D grafika, murakkab video ishlov berish yoki juda spetsifik uskuna bilan ishlaganda kerak bo'ladi. Bunday talab chiqsa, alohida native modul yozib, uni ilovaga ulaymiz.",
            },
            {
                q: "App Store va Play Market'ga kim joylashtiradi?",
                a: "Biz. Akkaunt sozlash, ikona va skrinshotlar tayyorlash, tavsif yozish, joylashtirish va moderatsiyadan o'tkazish narxga kiradi. Akkaunt sizning kompaniyangiz nomiga rasmiylashtiriladi, ya'ni ilova huquqi bizda emas, sizda qoladi. Rad javobi kelsa, sababini tuzatib qayta yuborish ham bizning zimmamizda. Moderatsiya odatda bir necha kundan bir haftagacha davom etadi.",
            },
            {
                q: "Menga ilova kerakmi yoki mobil sayt yetarlimi?",
                a: "Agar mijoz sizga kamdan-kam murojaat qilsa, mobilga moslashgan sayt yetarli va ancha arzon tushadi. Ilova takroriy foydalanish, push orqali qaytarish, oflayn ishlash yoki kamera va GPS kerak bo'lganda oqlanadi. Konsultatsiyada buni ochiq aytamiz — kerak bo'lmasa, sizga sayt yoki veb-ilovani tavsiya qilamiz.",
            },
            {
                q: "Ilova mavjud saytim yoki CRM tizimim bilan bog'lanadimi?",
                a: "Ha. Agar tizimingizda API bo'lsa, ilova o'sha bazaga ulanadi va ma'lumot bitta joyda qoladi. API bo'lmasa, uni biz yozamiz — bu keyinchalik sayt va admin panel uchun ham foyda beradi. 1C, amoCRM, Bitrix24 va bank to'lov shlyuzlari bilan integratsiya odatiy vazifa.",
            },
            {
                q: "Ilova kodi va ma'lumotlar bazasi kimga tegishli?",
                a: "Sizga. Loyiha sizning Git repozitoriyingizda olib boriladi, server va store akkauntlari ham sizning nomingizga ochiladi. Topshirish paytida kod, texnik hujjatlar va barcha kirish ma'lumotlari to'liq sizga o'tadi. Keyinchalik boshqa jamoa bilan davom etmoqchi bo'lsangiz, hech qanday to'siq bo'lmaydi. Kodni yopiq saqlash yoki bizga bog'lab qo'yish amaliyoti bizda yo'q.",
            },
            {
                q: "Ilova chiqqandan keyin qanday xarajatlar bo'ladi?",
                a: "Uchta doimiy xarajat qoladi: server va bulut xizmati, developer akkauntlar hamda texnik qo'llab-quvvatlash. iOS va Android har yili yangilanadi, shuning uchun ilovani vaqti-vaqti bilan moslashtirish kerak. Birinchi 6 oy qo'llab-quvvatlash narxga kiradi, keyin oylik shartnoma taklif qilamiz. Server xarajati foydalanuvchi soniga qarab o'zgaradi va uni oldindan hisoblab beramiz.",
            },
            {
                q: "Ilovaga onlayn to'lovni ulash mumkinmi?",
                a: "Ha, Payme, Click, Uzum va bank kartasi orqali to'lov Business tarifiga kiradi. Obuna va bo'lib to'lash stsenariylari ham qo'llab-quvvatlanadi. To'lov tizimi bilan shartnomani siz tuzasiz — bu qonun talabi, chunki mablag' bevosita sizning hisobingizga tushishi kerak. Texnik ulash va sinov bizning zimmamizda.",
            },
        ],
    },
    cta: {
        h: "Ilova g'oyangizni birga baholaymizmi?",
        p: "Bepul konsultatsiyada ilova sizga haqiqatan kerakmi yoki sayt yetarlimi — ochiq aytamiz. Keyin funksiyalar ro'yxati, aniq narx va muddatni yozma taklifda beramiz. Majburiyat yo'q, qo'ng'iroq qiling: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/projects/logistatrans-app.webp",
            alt: "Logistatrans mobil ilovasi — logistika uchun React Native ilova ekranlari",
            caption: "Logistatrans — haydovchi va dispetcher uchun mobil ilova, Play Market'da mavjud.",
        },
        {
            src: "/assets/img/projects/besh-market-app.webp",
            alt: "Besh Market mobil ilovasi — onlayn do'kon katalogi va savat ekranlari",
            caption: "Besh Market — katalog, savat, onlayn to'lov va buyurtma kuzatuvi bilan savdo ilovasi.",
        },
        {
            src: "/assets/img/projects/bobo-market-app.webp",
            alt: "Bobo Market mobil ilovasi — mahsulot katalogi va yetkazib berish ekranlari",
            caption: "Bobo Market — yetkazib berish va push orqali aksiyalarni yuborish moduli bilan.",
        },
        {
            src: "/assets/img/projects/myyurist-app.webp",
            alt: "My Yurist mobil ilovasi — onlayn yuridik maslahat xizmati ekranlari",
            caption: "My Yurist — onlayn yuridik maslahat: chat, hujjat yuklash va to'lov bitta ilovada.",
        },
        {
            src: "/assets/img/projects/firewise-app.webp",
            alt: "FireWise mobil ilovasi — yong'in xavfsizligi tekshiruvi uchun ilova ekranlari",
            caption: "FireWise — obyektlarni tekshirish, foto hisobot va oflayn rejim bilan xodimlar ilovasi.",
        },
    ],
    related: ["veb-ilovalar", "desktop-ilova", "crm-tizimlar", "ux-ui-dizayn", "telegram-bot"],
};

const ru = {
    meta: {
        title: "Разработка мобильного приложения — iOS и Android по одной цене, от 45 млн сум",
        description:
            "Разработка мобильного приложения в Innobek от 45 млн сум, и это цена сразу за iOS и Android. React Native, push-уведомления, оплата, публикация в App Store и Play Market.",
        keywords: [
            "разработка мобильного приложения",
            "стоимость мобильного приложения",
            "создать приложение ios",
            "создать приложение android",
            "react native разработка",
            "заказать мобильное приложение Ташкент",
            "публикация в play market",
            "мобильное приложение для бизнеса",
        ],
    },
    hero: {
        eyebrow: "Мобильные приложения / iOS и Android",
        h1: "Разработка мобильного приложения — iOS и Android по одной цене",
        lead:
            "Не нужны две команды и два бюджета. Мы делаем на React Native: из одной кодовой базы выходят iOS и Android, обе версии работают одинаково, а обновления попадают в оба стора одновременно. Публикация тоже входит в стоимость.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Наши приложения уже в Play Market",
            "iOS + Android по одной цене",
            "Тестовая сборка каждые 2 недели",
            "Код и аккаунты в сторах — ваши",
        ],
    },
    intro: {
        h: "Зачем бизнесу мобильное приложение и как оно создаётся",
        p: [
            "Мобильное приложение отличается от сайта двумя вещами. Первое — иконка постоянно на экране телефона, клиенту не нужно искать вас в поиске, он просто нажимает на неё. Второе — push-уведомления: статус заказа, акция или напоминание доходят за секунду, и, в отличие от SMS, бесплатно.",
            "Третья причина техническая: приложение использует возможности самого телефона. Камера сканирует штрих-код, GPS показывает курьера на карте, при обрыве связи данные сохраняются в памяти устройства, а вход идёт по отпечатку пальца или Face ID. В браузере большая часть этого либо недоступна, либо работает с ограничениями.",
            "При этом приложение нужно не каждому бизнесу. Если клиент обращается к вам раз или два в год, адаптивный сайт обойдётся заметно дешевле и полностью закроет задачу. Приложение окупается при регулярном использовании: доставка, образование, медицина, программа лояльности, логистика или рабочий инструмент для сотрудников.",
            "Команда Innobek работает на React Native, а бэкенд собирает на Nest.js. Приложения Logistatrans, Besh Market, Bobo Market, My Yurist и FireWise сделаны именно так и доступны в Play Market. Одна кодовая база означает, что бюджет не удваивается, а набор функций на обеих платформах совпадает.",
            "Порядок работы простой. Сначала вместе отбираем функции и оставляем в первой версии только то, что действительно нужно. Затем рисуем дизайн в Figma, вы сами прокликиваете прототип, и только после этого начинается разработка. Каждые две недели вы получаете работающую сборку — результат виден не в конце, а по ходу, и направление можно скорректировать.",
        ],
    },
    definition: {
        term: "Что такое мобильное приложение?",
        text:
            "Мобильное приложение — программа, устанавливаемая на телефон или планшет. Она отправляет push-уведомления, использует камеру, GPS и офлайн-хранилище устройства и распространяется через App Store и Play Market.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные дополнения — всё перечисленное есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и техническая оценка идеи",
            "Приоритизация функций: что войдёт в первую версию",
            "Полный дизайн и интерактивный прототип в Figma",
            "Единая кодовая база для iOS и Android (React Native)",
            "Бэкенд, API и база данных",
            "Админ-панель для управления контентом и пользователями",
            "Настройка системы push-уведомлений",
            "Иконка, скриншоты и описание для сторов",
            "Публикация в App Store и Play Market, прохождение модерации",
            "Подключение аналитики и отчётов о сбоях (crash reporting)",
            "Git-репозиторий и полное владение кодом на вашей стороне",
            "6 месяцев технической поддержки после запуска",
        ],
    },
    benefits: {
        eyebrow: "Зачем нужно",
        h: "Что мобильное приложение даёт бизнесу",
        sub: "Приложение — не ещё один рекламный канал, а инструмент удержания клиента.",
        items: [
            {
                t: "Push — самый дешёвый канал связи",
                d: "SMS стоит денег за каждое сообщение, письма часто не открывают. Push бесплатен и виден на экране сразу: статус заказа, акция, напоминание и персональное предложение доходят мгновенно.",
            },
            {
                t: "Растут повторные заказы",
                d: "Клиент с установленным приложением не ищет вас в Google и не попадает на рекламу конкурента. Он нажимает иконку, повторяет прошлый заказ и не вводит платёжные данные заново.",
            },
            {
                t: "Доступны все возможности телефона",
                d: "Сканирование и загрузка документов через камеру, отслеживание доставки по GPS, офлайн-режим, вход по отпечатку, доступ к контактам и календарю — всё это доступно в приложении.",
            },
            {
                t: "Один код, две платформы",
                d: "На React Native версии для iOS и Android собираются из одного кода. Бюджет не удваивается, правки выходят на обеих платформах одновременно, и разницы в функциях между версиями не остаётся.",
            },
            {
                t: "Рабочий инструмент для сотрудников",
                d: "Для курьера, продавца, кладовщика или выездного специалиста приложение заменяет бумажный отчёт. Данные вносятся на месте, а руководство видит их в реальном времени.",
            },
            {
                t: "Измеримое поведение пользователей",
                d: "Аналитика показывает каждый экран: где человек останавливается, какую кнопку не нажимает, сколько людей возвращается второй раз. Следующую версию вы планируете по цифрам, а не по догадкам.",
            },
            {
                t: "Меньше шагов до оплаты",
                d: "Данные карты сохраняются один раз, дальше достаточно двух нажатий. С интеграцией Payme, Click и Uzum доля брошенных оплат заметно ниже, чем на сайте.",
            },
            {
                t: "Сигнал доверия на рынке",
                d: "Приложение, прошедшее модерацию App Store и Play Market, показывает, что компания работает всерьёз. Для нового бренда и участника тендеров это весомый аргумент.",
            },
        ],
    },
    audience: {
        eyebrow: "Кто заказывает",
        h: "Какому бизнесу подходит мобильное приложение",
        sub: "Случаи, когда клиент или сотрудник возвращается в систему снова и снова.",
        items: [
            {
                t: "Доставка и торговля",
                d: "Каталог, корзина, онлайн-оплата, отслеживание заказа и акции через push-уведомления.",
            },
            {
                t: "Логистика и курьерская служба",
                d: "Приложение водителя: маршрут, GPS, сканирование накладных и обновление статуса на месте.",
            },
            {
                t: "Образование и курсы",
                d: "Видеоуроки, тесты, посещаемость, сертификаты и напоминания о домашних заданиях.",
            },
            {
                t: "Медицина и здоровье",
                d: "Запись к врачу, результаты анализов, напоминания о приёме лекарств и связь с клиникой.",
            },
            {
                t: "Лояльность и сервис",
                d: "Бонусные баллы, цифровая карта, персональные предложения и онлайн-запись в очередь.",
            },
            {
                t: "Внутреннее корпоративное приложение",
                d: "Смены и посещаемость, задачи, складской сканер и отчёты выездных сотрудников.",
            },
            {
                t: "Фитнес-клубы и салоны красоты",
                d: "Абонемент, расписание занятий, запись к мастеру и напоминание перед визитом.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость мобильного приложения — три тарифа",
        sub: "Цена в каждом тарифе указана сразу за iOS и Android вместе.",
        note:
            "Итоговая смета подтверждается после бесплатного анализа и согласования списка функций. Оплата идёт поэтапно, по спринтам. Платежи за аккаунты разработчика (Apple — 99 долларов в год, Google — 25 долларов разово) и облачные расходы оплачиваются провайдеру напрямую.",
        tiers: [
            {
                name: "Start",
                tagline: "Первая версия с основным функционалом",
                price: "45 000 000",
                priceNote: "сум",
                term: "3–4 месяца",
                best: "Компаниям, которым нужно быстро проверить идею на рынке",
                features: [
                    "iOS и Android из одного кода (React Native)",
                    "Индивидуальный дизайн в Figma",
                    "Регистрация, вход и профиль",
                    "4–6 основных экранов и один продуктовый сценарий",
                    "Push-уведомления",
                    "Бэкенд, API и админ-панель",
                    "Публикация в App Store и Play Market",
                    "Аналитика и crash reporting",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "Полноценный продукт с оплатой и интеграциями",
                price: "90 000 000",
                priceNote: "сум",
                term: "5–8 месяцев",
                best: "Проектам с несколькими ролями, онлайн-оплатой и интеграцией с внешними системами",
                featured: true,
                features: [
                    "Всё, что входит в тариф Start",
                    "10–18 экранов и расширенная логика",
                    "Онлайн-оплата: Payme, Click, Uzum и банковская карта",
                    "Несколько ролей: клиент, курьер, менеджер, администратор",
                    "Карты, GPS-отслеживание и геолокация",
                    "Камера: сканер QR и штрих-кодов, загрузка документов",
                    "Офлайн-режим и синхронизация данных",
                    "Интеграция с CRM, 1С или ERP",
                    "Программа лояльности и сегментированные push-уведомления",
                    "Мультиязычность, вход по отпечатку и Face ID",
                    "Техническая документация и полная передача кода",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Для высоких нагрузок и особых требований",
                price: "По договору",
                priceNote: "",
                term: "По проекту",
                best: "Крупным системам с нативными модулями, оборудованием или искусственным интеллектом",
                features: [
                    "Нативные модули на Swift и Kotlin",
                    "Искусственный интеллект: рекомендации, распознавание, голосовое управление",
                    "Работа с оборудованием: Bluetooth, NFC, чековые принтеры, терминалы",
                    "Несколько стран, валют и юридических лиц",
                    "Инфраструктура под нагрузку и мониторинг",
                    "Аудит безопасности и защита персональных данных",
                    "Модель выделенной продуктовой команды",
                    "Поддержка по согласованному SLA",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как создаётся мобильное приложение",
        sub: "Работаем спринтами — каждые две недели вы ставите тестовую сборку на свой телефон.",
        steps: [
            {
                t: "Анализ и определение объёма",
                d: "Описываем, кто пользователь, какую задачу закрывает приложение и что войдёт в первую версию. На этом этапе фиксируются точная цена и срок.",
                time: "1–2 недели",
            },
            {
                t: "Дизайн и прототип",
                d: "Все экраны рисуются в Figma. Интерактивный прототип вы прокликиваете на телефоне — правки вносятся до написания кода, и это экономит бюджет.",
                time: "3–5 недель",
            },
            {
                t: "Бэкенд и API",
                d: "Собираем базу данных, API и админ-панель. Если у вас уже есть система, приложение подключается к той же базе и данные не дублируются.",
                time: "3–6 недель",
            },
            {
                t: "Разработка приложения",
                d: "Экраны собираются по очереди, в конце каждого спринта вы получаете работающую сборку. Вы проверяете её на реальном телефоне и даёте обратную связь.",
                time: "6–16 недель",
            },
            {
                t: "Тестирование и исправления",
                d: "Проверяем на разных моделях телефонов, размерах экрана, медленном интернете и при обрыве связи. Найденные дефекты закрываются до релиза.",
                time: "2–3 недели",
            },
            {
                t: "Публикация в сторах",
                d: "Размещаем в App Store и Play Market, проходим модерацию, запускаем аналитику и каналы push-уведомлений.",
                time: "1–3 недели",
            },
            {
                t: "Поддержка и развитие",
                d: "В первые месяцы следим за метриками, исправляем ошибки и выбираем функции следующей версии по реальной статистике использования.",
                time: "6 месяцев и далее",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Мобильные приложения, которые мы сделали",
        sub: "Все собраны на React Native и опубликованы в Play Market.",
        cta: "Смотреть все проекты",
        slugs: ["logistatrans-app", "besh-market-app", "bobo-market-app", "myyurist-app", "firewise-app", "anibla"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы о мобильных приложениях",
        sub: "Короткие ответы на то, что спрашивают чаще всего перед заказом.",
        items: [
            {
                q: "Сколько стоит разработка мобильного приложения?",
                a: "Цена начинается от 45 000 000 сум, и это сумма сразу за iOS и Android. В базовый тариф входят регистрация, 4–6 основных экранов, push-уведомления, бэкенд и публикация в сторах. Если нужны оплата, карты, офлайн-режим и несколько ролей, тариф начинается от 90 000 000 сум. Точная цифра фиксируется после согласования списка функций.",
            },
            {
                q: "За iOS и Android платят отдельно?",
                a: "Нет. На React Native обе платформы выходят из одной кодовой базы, поэтому цена одна. Это заметно снижает бюджет и гарантирует, что обновления попадут в оба стора одновременно. Отдельно оплачиваются только аккаунты разработчика Apple и Google — напрямую провайдеру. Дизайн, бэкенд и админ-панель тоже делаются один раз на обе платформы, поэтому объём работ не дублируется.",
            },
            {
                q: "Сколько времени занимает разработка приложения?",
                a: "Тариф Start сдаётся за 3–4 месяца, Business — за 5–8 месяцев. Поскольку мы работаем спринтами, первую рабочую сборку вы поставите на телефон уже через 5–6 недель. Срок зависит от количества функций и сложности интеграций с внешними системами. Больше всего времени обычно занимают оплата и связка с CRM, поэтому их планируем в начале проекта. Если решения на вашей стороне принимаются быстро, срок сокращается.",
            },
            {
                q: "React Native уступает нативной разработке?",
                a: "Для большинства бизнес-приложений разница незаметна: интерфейс работает плавно, push, камера, GPS, оплата и офлайн-режим доступны полностью. Нативный код нужен только при тяжёлой 3D-графике, сложной обработке видео или очень специфичном оборудовании. В таком случае мы пишем отдельный нативный модуль и подключаем его к приложению.",
            },
            {
                q: "Кто публикует приложение в App Store и Play Market?",
                a: "Мы. Настройка аккаунтов, подготовка иконки и скриншотов, написание описания, размещение и прохождение модерации входят в стоимость. Аккаунт оформляется на вашу компанию, то есть права на приложение остаются у вас, а не у нас. При отказе мы устраняем причину и отправляем заявку повторно.",
            },
            {
                q: "Мне нужно приложение или достаточно мобильного сайта?",
                a: "Если клиент обращается к вам редко, адаптивного сайта достаточно и он обойдётся заметно дешевле. Приложение оправдано при регулярном использовании, возврате через push, работе офлайн или необходимости камеры и GPS. На консультации говорим честно — если приложение не нужно, предложим сайт или веб-приложение.",
            },
            {
                q: "Можно ли связать приложение с моим сайтом или CRM?",
                a: "Да. Если у вашей системы есть API, приложение подключается к той же базе и данные остаются в одном месте. Если API нет, мы его напишем — позже это пригодится сайту и админ-панели. Интеграции с 1С, amoCRM, Bitrix24 и банковскими платёжными шлюзами для нас обычная задача.",
            },
            {
                q: "Кому принадлежат код и база данных?",
                a: "Вам. Проект ведётся в вашем Git-репозитории, серверы и аккаунты в сторах оформляются на вашу компанию. При сдаче код, техническая документация и все доступы полностью переходят к вам. Если позже вы захотите продолжить с другой командой, никаких препятствий не возникнет. Практики закрывать код или привязывать клиента к себе у нас нет.",
            },
            {
                q: "Какие расходы остаются после запуска приложения?",
                a: "Постоянных расходов три: сервер и облачные сервисы, аккаунты разработчика и техническая поддержка. iOS и Android обновляются ежегодно, поэтому приложение нужно периодически адаптировать. Первые 6 месяцев поддержки входят в стоимость, дальше предлагаем договор с ежемесячной оплатой. Стоимость сервера зависит от числа пользователей, и мы рассчитываем её заранее.",
            },
            {
                q: "Можно ли подключить к приложению онлайн-оплату?",
                a: "Да, оплата через Payme, Click, Uzum и банковскую карту входит в тариф Business. Поддерживаются также подписки и рассрочка. Договор с платёжной системой заключаете вы — это требование закона, деньги должны поступать напрямую на ваш счёт. Техническое подключение и тестирование берём на себя.",
            },
        ],
    },
    cta: {
        h: "Обсудим идею вашего приложения?",
        p: "На бесплатной консультации честно скажем, нужно ли вам приложение или хватит сайта. Затем пришлём письменное предложение со списком функций, точной ценой и сроком. Без обязательств, звоните: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/projects/logistatrans-app.webp",
            alt: "Мобильное приложение Logistatrans — экраны React Native приложения для логистики",
            caption: "Logistatrans — приложение для водителя и диспетчера, доступно в Play Market.",
        },
        {
            src: "/assets/img/projects/besh-market-app.webp",
            alt: "Мобильное приложение Besh Market — экраны каталога и корзины интернет-магазина",
            caption: "Besh Market — торговое приложение с каталогом, корзиной, оплатой и отслеживанием заказа.",
        },
        {
            src: "/assets/img/projects/bobo-market-app.webp",
            alt: "Мобильное приложение Bobo Market — экраны каталога товаров и доставки",
            caption: "Bobo Market — доставка и модуль рассылки акций через push-уведомления.",
        },
        {
            src: "/assets/img/projects/myyurist-app.webp",
            alt: "Мобильное приложение My Yurist — экраны сервиса онлайн-консультаций юриста",
            caption: "My Yurist — онлайн-консультация юриста: чат, загрузка документов и оплата в одном приложении.",
        },
        {
            src: "/assets/img/projects/firewise-app.webp",
            alt: "Мобильное приложение FireWise — экраны приложения для проверок пожарной безопасности",
            caption: "FireWise — приложение для сотрудников: проверка объектов, фотоотчёт и офлайн-режим.",
        },
    ],
    related: ["veb-ilovalar", "desktop-ilova", "crm-tizimlar", "ux-ui-dizayn", "telegram-bot"],
};

const content = { uz, ru };

export default content;
